import React, { useEffect, useRef } from 'react';
import { useThree } from '@react-three/fiber';
import { Center, Environment, Sky, OrbitControls } from '@react-three/drei';
import * as THREE from 'three';
import gsap from 'gsap';
import Ocean from './Ocean';
import { Yacht_Full } from './Yacht-Full';
import { Yacht_Hull_Top } from './Yacht-Hull-Top';
import { Yacht_Hull_Bottom } from './Yacht-Hull-Bottom';
import { Yacht_Hull_Lining } from './Yacht-Hull-Lining';
import { Yacht_Upholstery } from './Yacht-Upholstery';
import { Yacht_Upholstery_P } from './Yacht-Upholstery-P';
import { Yacht_Upholstery_S } from './Yacht-Upholstery-S';
import { Yacht_Floor } from './Yacht-Floor';
import { Yacht_Hull_Dodatki } from './Yacht-Hull-Dodatki';

export default function Scene({ 
    activePanel, 
    color1, 
    color2, 
    color3, 
    color4, 
    color5, 
    color6, 
    color7,
    fridge,
    backAdd,
  }) {
  const { camera } = useThree();

  useEffect(() => {
    // Set initial camera position and target
    camera.position.set(-30, 0, 100); // Adjust this to shift the camera left
    camera.lookAt(0, 0, 0); // Ensure the camera is looking at the center of the scene

    const startPosition = camera.position.clone();
    const targetPosition = new THREE.Vector3();
    let targetZoom = 1;
    {/* */}
    if (activePanel === 0) {
        targetPosition.set(60, 40, 60);
        targetZoom = 1.5;
    } else if (activePanel === 1) {
        targetPosition.set(50, 20, 90);
        targetZoom = 1.75;
    } else if (activePanel === 2) {
        targetPosition.set(50, 10, 90);
        targetZoom = 1.65;
    } else if (activePanel === 3) {
        targetPosition.set(45, 10, 45);
        targetZoom = 1.6;
    } else if (activePanel === 4) {
        targetPosition.set(30, 25, 20);
        targetZoom = 1.95;
    } else if (activePanel === 5) {
        targetPosition.set(30, 25, 30);
        targetZoom = 2.25;
    } else if (activePanel === 6) {
        targetPosition.set(30, 25, 30);
        targetZoom = 2.25;
    } else if (activePanel === 7) {
        targetPosition.set(20, 40, 20);
        targetZoom = 1.25;
    } else {
        targetPosition.set(60, 40, 60);
        targetZoom = 1.75;
    }

    const positionAnimation = { 
      x: startPosition.x, 
      y: startPosition.y, 
      z: startPosition.z 
    };

    gsap.to(positionAnimation, {
      x: targetPosition.x,
      y: targetPosition.y,
      z: targetPosition.z,
      duration: 2,
      onUpdate: () => {
        camera.position.set(positionAnimation.x, positionAnimation.y, positionAnimation.z);
        camera.updateProjectionMatrix();
      }
    });

    gsap.to(camera, {
      zoom: targetZoom,
      duration: 2,
      onUpdate: () => camera.updateProjectionMatrix()
    });

  }, [activePanel, camera]);

  let modelPosition;
  let groupPosition;
  let groupRotation;

  if (activePanel === 1 || activePanel === 5) {
    modelPosition = [0, 0.1, 0.5];
    groupPosition = [0, -1, -1.25];
    groupRotation = [0,0,0]
  } else if (activePanel === 2) {
    modelPosition = [0.5, 0.1, 0.5];
    groupPosition = [0.5, -0.275, -1.25];
    groupRotation = [0,0,0]
  } else if (activePanel === 3) {
    modelPosition = [0, 0.1, -0.5];
    groupPosition = [-0.25, -1, -1.25];
    groupRotation = [0,Math.PI,0]
  } else if (activePanel === 4) {
    modelPosition = [0.1, 0.25, 0.5];
    groupPosition = [0, -1.5, -2];
    groupRotation = [0,0,0]
  } else {
    modelPosition = [0, 0.1, 0.5];
    groupPosition = [0, -1, -1.25];
    groupRotation = [0,0,0]
  }

  return (
    <>
      <group position={[0, 0, 0]}>
        <Center scale={0.8}>
          <pointLight position={[100, 100, 100]} />
          <pointLight position={[-100, -100, -100]} />
          <Ocean />
          <group scale={1} position={[-10, -2.5, 0]} rotation={[0, 0, Math.PI / 70]}>
            <Yacht_Full fridge={fridge}/>
            <Yacht_Hull_Top color1={color1}/>
            <Yacht_Hull_Bottom color2={color2}/>
            <Yacht_Hull_Lining color3={color3}/>
            <Yacht_Upholstery color4={color4}/>
            <Yacht_Upholstery_P color5={color5}/>
            <Yacht_Upholstery_S color6={color6}/>
            <Yacht_Floor color7={color7}/>
            <Yacht_Hull_Dodatki color1={color1} backAdd={backAdd} fridge={fridge}/>
          </group>
          
          <OrbitControls 
            minPolarAngle={0} 
            maxPolarAngle={(Math.PI / 2) - (Math.PI/45)}
            enablePan={false}
            minDistance={30}
            maxDistance={150}
          />
        </Center>
      </group>
    </>
  );
}
